import fetchLogger from "./fetchLogger";

/** DELETE /api/v1/issues/:id */
export default async function deleteIssue(id) {
  const result = { return: 0, msg: "Failed deleting issue", data: null };

  const res = await fetchLogger({
    method: "DELETE",
    url: `/api/v1/issues/${id}`,
  });

  if (res.ok) {
    result.return = 1;
    result.msg = "Issue deleted";
    result.data = res.data?.data || null;
  } else {
    const message = res.data?.message;
    result.msg = Array.isArray(message) ? message.join(", ") : message || result.msg;
  }

  return result;
}
